/**
 * @file paddlex 用户信息
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {Button, Col, Form, Input, Radio, Row, Select} from 'antd';

import PaddleTextarea from '../paddle-textarea/PaddleTextarea';
import industryMap from '../../data/industryMap.json';
import collegeMap from '../../data/collegeMap.json';
import developerPositionMap from '../../data/developerPositionMap.json';
import {FormInstance} from 'antd/es/form';
import {generateShouldUpdate} from '../../../../../../utils/antd-form-should-update';

const regionSource = collegeMap;


const collegeProvinceOptions = regionSource.map(data => ({
    value: data.province,
    text: data.province
}));

interface IUserInfoFormProps {
    form: FormInstance;
    verifyCodeImg: string;
    getVerifyCode: () => void;
    onFormSubmit: (feildValue: any) => void;
    onFormCancel: () => void;
}

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 5}
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 19}
    }
};

const formItemDividerLayout = {
    labelCol: {span: 23}
};

const UserInfoForm: React.FC<IUserInfoFormProps> = (props) => {
    const {
        form,
        verifyCodeImg,
        getVerifyCode,

        onFormSubmit,
        onFormCancel
    } = props;
    const {
        resetFields
    } = form;

    return (
        <Form
            form={form}
            className="paddle-lab-user-info-form"
            onFinish={onFormSubmit}
            {...formItemLayout}
        >
            <Form.Item
                labelAlign="left"
                label="昵称"
                name="nickname"
                rules={[{required: true, message: '请输入昵称'}]}
            >
                <Input
                    className="paddle-lab-user-info-form-input"
                    size="large"
                    placeholder="请输入昵称"
                />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="姓名"
                name="username"
                rules={[{required: true, message: '请输入姓名'}]}
            >
                <Input
                    className="paddle-lab-user-info-form-input"
                    size="large"
                    placeholder="请输入姓名"
                />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="邮箱"
                name="email"
                rules={[
                    {required: true, message: '请输入常用邮箱'},
                    {type: 'email', message: '请输入正确的邮箱'}
                ]}
            >
                <Input
                    className="paddle-lab-user-info-form-input"
                    size="large"
                    placeholder="请输入常用邮箱"
                />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="手机号"
                name="mobile"
                rules={[
                    {required: true, message: '请输入手机号'},
                    {pattern: /^1\d{10,10}/, message: '请输入正确的手机号'}
                ]}
            >
                <Input
                    className="paddle-lab-user-info-form-input"
                    size="large"
                    placeholder="方便飞桨团队与您交流"
                />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="您的身份"
                name="centerUserType"
                rules={[{required: true, message: '请选择身份'}]}
                initialValue="开发者"
            >
                <Radio.Group>
                    <Radio value="开发者">开发者</Radio>
                    <Radio value="学生">学生</Radio>
                    <Radio value="其他">其他</Radio>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                noStyle
                shouldUpdate={generateShouldUpdate(['centerUserType'])}
            >
                {({getFieldValue}) => {
                    const theCenterUserType = getFieldValue('centerUserType');
                    const developerInfoFormVisible = !theCenterUserType || theCenterUserType === '开发者';
                    const otherInfoFormVisible = theCenterUserType === '其他';
                    return (
                        <React.Fragment>
                            <div
                                style={{
                                    display: developerInfoFormVisible ? undefined : 'none'
                                }}
                            >
                                <Form.Item
                                    className="paddle-lab-user-info-form-sub-form"
                                    labelAlign="left"
                                    label="请完善「开发者」角色信息"
                                    {...formItemDividerLayout}
                                />
                                <Form.Item
                                    className="paddle-lab-user-info-form-item-location"
                                    labelAlign="left"
                                    label="所在地"
                                    required
                                >
                                    <Row gutter={20}>
                                        <Col sm={12}>
                                            <Form.Item
                                                name="developerLocationProvince"
                                                rules={[{required: developerInfoFormVisible, message: '请选择省份'}]}
                                            >
                                                <Select
                                                    className="paddle-lab-user-info-form-select"
                                                    dropdownClassName="paddle-lab-user-info-form-select-dropdown"
                                                    size="large"
                                                    placeholder="请选择省份"
                                                    onChange={() => resetFields(['developerLocationCity'])}
                                                >
                                                    {collegeProvinceOptions.map(item => (
                                                        <Select.Option
                                                            key={item.value}
                                                            value={item.value}
                                                        >
                                                            {item.text}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col sm={12}>
                                            <Form.Item
                                                noStyle
                                                shouldUpdate={generateShouldUpdate(['developerLocationProvince'])}
                                            >
                                                {({getFieldValue}) => {
                                                    // 开发者省份城市联动
                                                    const selectedCollegeProvince: string | undefined = getFieldValue('developerLocationProvince');
                                                    const cityOptions = (() => {
                                                        const selectedCollegeProvinceItem = collegeMap.find(province => province.province === selectedCollegeProvince);
                                                        const cityList = selectedCollegeProvinceItem ? selectedCollegeProvinceItem.cities : [];
                                                        return cityList.map(city => ({
                                                            value: city.name,
                                                            text: city.name
                                                        }));
                                                    })();
                                                    return (
                                                        <Form.Item
                                                            name="developerLocationCity"
                                                            rules={[{
                                                                required: developerInfoFormVisible,
                                                                message: '请选择城市'
                                                            }]}
                                                        >
                                                            <Select
                                                                className="paddle-lab-user-info-form-select"
                                                                dropdownClassName="paddle-lab-user-info-form-select-dropdown"
                                                                size="large"
                                                                placeholder="请选择城市"
                                                            >
                                                                {cityOptions.map(item => (
                                                                    <Select.Option
                                                                        key={item.value}
                                                                        value={item.value}
                                                                    >
                                                                        {item.text}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    );
                                                }}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form.Item>
                                <Form.Item
                                    labelAlign="left"
                                    label="行业"
                                    name="industry"
                                    rules={[{required: developerInfoFormVisible, message: '请选择所属行业'}]}
                                >
                                    <Select
                                        className="paddle-lab-user-info-form-select"
                                        dropdownClassName="paddle-lab-user-info-form-select-dropdown"
                                        size="large"
                                        placeholder="请选择所属行业"
                                    >
                                        {industryMap.map(item => (
                                            <Select.Option
                                                key={item.value}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    labelAlign="left"
                                    label="公司"
                                    name="developerCompany"
                                    rules={[{required: developerInfoFormVisible, message: '请选择所属行业'}]}
                                >
                                    <Input
                                        className="paddle-lab-user-info-form-input"
                                        size="large"
                                        placeholder="请输入公司名称"
                                    />
                                </Form.Item>
                                <Form.Item
                                    labelAlign="left"
                                    label="职位"
                                    name="developerPosition"
                                    rules={[{required: developerInfoFormVisible, message: '请选择职位'}]}
                                >
                                    <Select
                                        className="paddle-lab-user-info-form-select"
                                        dropdownClassName="paddle-lab-user-info-form-select-dropdown"
                                        size="large"
                                        placeholder="请选择职位"
                                    >
                                        {developerPositionMap.map(item => (
                                            <Select.Option
                                                key={item.value}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    labelAlign="left"
                                    label="应用场景"
                                    name="scene"
                                    rules={[{required: developerInfoFormVisible, message: '请输入深度学习应用场景'}]}
                                >
                                    <PaddleTextarea
                                        className="paddle-lab-user-info-form-textarea"
                                        maxLength={100}
                                        rows={8}
                                        placeholder="请输入深度学习应用场景"
                                    />
                                </Form.Item>
                            </div>

                            <div
                                style={{
                                    display: otherInfoFormVisible ? undefined : 'none'
                                }}
                            >
                                <Form.Item
                                    className="paddle-lab-user-info-form-sub-form"
                                    labelAlign="left"
                                    label="请完善您的角色信息"
                                    {...formItemDividerLayout}
                                />
                                <Form.Item
                                    labelAlign="left"
                                    label="其他身份"
                                    name="otherUserType"
                                    rules={[{required: otherInfoFormVisible, message: '请输入身份'}]}
                                >
                                    <Input
                                        className="paddle-lab-user-info-form-input"
                                        size="large"
                                        placeholder="请输入身份"
                                    />
                                </Form.Item>
                            </div>
                        </React.Fragment>
                    );
                }}
            </Form.Item>
            <Form.Item
                className="verify-code-form-item-wrap"
                labelAlign="left"
                label="验证码"
                required
            >
                <Form.Item
                    className="verify-code-wrap"
                    name="verifyCode"
                    rules={[{required: true, message: '请输入验证码'}]}
                >
                    <Input
                        className="paddle-lab-user-info-form-input verify-code-input"
                        size="large"
                        placeholder="请输入验证码"
                    />
                </Form.Item>
                <div className="verify-code-img-wrap" onClick={getVerifyCode}>
                    <img alt="验证码" src={verifyCodeImg} />
                </div>
                <i className="verify-code-img-reload" onClick={getVerifyCode} />
            </Form.Item>

            <Form.Item
                labelAlign="left"
                wrapperCol={{sm: {offset: 5, span: 19}, xs: {offset: 0, span: 24}}}
            >
                <Button
                    className="paddle-lab-user-info-form-btn"
                    size="large"
                    type="primary"
                    htmlType="submit"
                >
                    保存
                </Button>
                <Button
                    className="paddle-lab-user-info-form-btn"
                    size="large"
                    onClick={onFormCancel}
                >
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
};

export default UserInfoForm;
